var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-5 bg-white"},[_c('div',{staticClass:"container"},[_c('Dates',{attrs:{"types":_vm.types,"theme-color":_vm.surrounding.style}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }